$(document).ready(function() {
    // check if .da-restock-alerts-container-v1 input is present
    if ($('.da-restock-alerts-container-v1 input').length) {
      // run code to add class to select element
      $('.da-restock-alerts-container-v1 input').addClass('quantity-selector__input');
      $('.da-restock-alerts-container-v1 select').addClass('options-selection__input-select');
    }
  });
  